import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { site } from "@/mocks/site";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="w-full bg-secondary-100 text-secondary-900">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-xl"></i>
              </span>
              <span className="font-heading text-lg font-black tracking-tight text-foreground-950">
                导航爆料
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-6 text-secondary-700">
              {site.slogan}。把热点按主题归类，话题、事件、人物与机构分类清晰，想追哪个瓜就进哪一栏。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-bold text-foreground-950">内容分类</h3>
            <ul className="mt-4 space-y-3 text-sm text-secondary-700">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/category/${c.slug}`}
                    className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap transition-colors hover:text-primary-600"
                  >
                    <i className="ri-arrow-right-s-line text-primary-500"></i>
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-foreground-950">站点导航</h3>
            <ul className="mt-4 space-y-3 text-sm text-secondary-700">
              <li>
                <Link to="/" className="cursor-pointer transition-colors hover:text-primary-600">首页</Link>
              </li>
              <li>
                <Link to="/about" className="cursor-pointer transition-colors hover:text-primary-600">关于我们</Link>
              </li>
              <li>
                <Link to="/faq" className="cursor-pointer transition-colors hover:text-primary-600">常见问题</Link>
              </li>
              <li>
                <Link to="/category/huati" className="cursor-pointer transition-colors hover:text-primary-600">最新内容</Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-foreground-950">联系我们</h3>
            <ul className="mt-4 space-y-3 text-sm text-secondary-700">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500"></i>
                <a href={`mailto:${site.email}`} className="break-all whitespace-normal transition-colors hover:text-primary-600">
                  {site.email}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-primary-500"></i>
                工作日 9:00 – 18:00 在线
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-secondary-300/60 pt-6 sm:flex-row">
          <p className="text-xs text-secondary-600">
            © {year} {site.name} 版权所有 · 内容仅供参考
          </p>
          <div className="flex items-center gap-4 text-xs text-secondary-600">
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-shield-check-line text-primary-600"></i>信息有出处
            </span>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-feedback-line text-primary-600"></i>欢迎纠错
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}